import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "m10.84 13.686 2.965-1.687-2.965-1.685z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5zm5.435 10.999c-.131.49-.513.874-1.003 1.007-.875.237-4.396.24-4.432.24s-3.558-.003-4.432-.239a1.426 1.426 0 0 1-1.003-1.009A15.074 15.074 0 0 1 6.328 12c-.005-.921.074-1.841.237-2.748.13-.491.513-.876 1.003-1.009.874-.236 4.396-.239 4.431-.239s3.557.003 4.432.239c.49.134.873.518 1.003 1.01.163.907.242 1.827.237 2.748.005.921-.074 1.841-.237 2.748z"
  })]
}), 'YoutubeRing');